<template>
  <div class="row">
    <div class="col">
      {{round.number}}
      <span v-if="totalRounds">of {{totalRounds}}</span>
    </div>
    <div class="col" v-for="player in players" v-bind:key="player.name">
      <playerscore
        v-if="canScore(player)"
        :key="player.name"
        :gameId="gameId"
        :playerName="player.name"
        :currentScore="scoreFor(player)"
        :claimFocus="player.name == playerToFocus()"
        :completionType="completionType"
      />
      <span v-else-if="hasScore(player)">{{scoreFor(player).score}}</span>
    </div>
  </div>
</template>

<script>
import playerscore from "./PlayerScore"

export default {
  name: "currentround",
    components: {
        playerscore    
    },
  props: ["round", "totalRounds", "players", "playerTurn", "gameId", "gameOver", "completionType"],
  methods: {
      playerToFocus: function() {
          return this.players.filter(player => !this.hasScore(player))[0].name
      },
    scoreFor: function(player) {
      return this.round.playerScores[player.name];
    },
    hasScore: function(player) {
      return player.name in this.round.playerScores;
    },
    canScore(player) {
      return (
          !this.gameOver && 
        (this.playerTurn == null ||
          this.playerTurn.name == player.name)
      );
    }
  },
  created() {
    /* eslint-disable no-console */
    console.log('CurrentRound created. ')
    /* eslint-enable no-console */
  },
  mounted() {
    /* eslint-disable no-console */
    console.log('CurrentRound mounted. ' + this.playerToFocus())
    /* eslint-enable no-console */
  }
};
</script>

<style scoped>
.container {
  display: flex; /* or inline-flex */
  flex-direction: column;
}

.row {
  display: flex; /* or inline-flex */
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: space-around;
  align-content: center;
  justify-content: space-between;
}
.row > * {
  flex: 1 100%;
}

.col {
  padding: 5px;
  
  line-height: 15px;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}

.row:nth-child(even){
  background-color: #dcdcdc;
}
.row:nth-child(odd){
  background-color: #eeeeee;
}
</style>